'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { resetSchemaAction } from './resetSchemaAction';
import Error from '@/components/Error';
import ErrorBoundary from '@/components/ErrorBoundary';
import { QuickLinks } from '@/components/QuickLinks';
import SubmitButton from '@/components/SubmitButton';
function ResetSchema() {
  const $ = _c(1);
  if (process.env.NEXT_PUBLIC_MOCK_GRAPHQL !== "1") {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QuickLinks id="reset-schema"><ErrorBoundary errorComponent={Error}><Suspense fallback={null}><form action={resetSchemaAction}><SubmitButton>Reset Schema</SubmitButton></form></Suspense></ErrorBoundary></QuickLinks>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default ResetSchema;